import { regStepIds } from '../../../../../utils/eventConstants';

// The steps a hybrid registration can only be on once the gate has been shown. Anything
// earlier is still pre-gate: the division list itself, and the Add Partner panel that a
// doubles row opens straight off that list without going through Continue.
const POST_GATE_STEPS = [
    regStepIds.UPGRADE,
    regStepIds.QUESTIONS,
    regStepIds.CONFIRM,
    regStepIds.PAYMENT,
    regStepIds.PAYMENT_WAIT,
];

export function getPowerGateFlags({
    areAllDivisionsAnnualPowerOnly,
    isHybrid,
    wasAnnualPowerAtStart,
    hasPowerDivisionSelected,
    isManagementStep,
    regStepId,
}) {
    // A hybrid registration turns into a Power journey at the gate, not at the tick box —
    // before it the player has not been told Power is involved yet and can still deselect
    // their way out of it, so the tracker would appear, read "Register", and imply the
    // upgrade was already done. Once past the gate it stays, including after the upgrade
    // flips the user to annual Power mid-checkout, which is why this reads the
    // start-of-flow snapshot.
    const isHybridPowerFlow = isHybrid &&
        !wasAnnualPowerAtStart &&
        hasPowerDivisionSelected &&
        POST_GATE_STEPS.includes(regStepId);

    // The password is an access check that runs before the journey the tracker describes, so
    // it has no place on it: the tracker's fallback step is "Register", which would read as
    // step 2 and send the player backwards to step 1 when the gate follows. An all-Power event
    // reaches this through areAllDivisionsAnnualPowerOnly, which holds at every step.
    const isEventAccessStep = regStepId === regStepIds.PASSWORD;

    const isPowerGateStep = (areAllDivisionsAnnualPowerOnly || isHybridPowerFlow) &&
        !isManagementStep &&
        !isEventAccessStep;

    // Switching or adding divisions can hit the same gate, and there the header showed only
    // "Upgrade to Power" and the player's name — no reason why. Those flows get the gate's
    // headline but not its tracker: "Annual Power / Register / Checkout" would misdescribe a
    // switch, and relocating the back and close would reshape a management flow AC6 freezes.
    const isManagementGateStep = isHybridPowerFlow &&
        isManagementStep &&
        regStepId === regStepIds.UPGRADE;

    return {
        isHybridPowerFlow,
        isPowerGateStep,
        isManagementGateStep,
        isPowerGateHeaderStep: isPowerGateStep && regStepId === regStepIds.UPGRADE,
    };
}
